export const messages = {
  reply: {
    sendButton: {
      id: 'secureMessage.Reply.SendButton',
      defaultMessage: 'Send Message',
    },
    cancelButton: {
      id: 'secureMessage.Reply.CancelButton',
      defaultMessage: 'Cancel',
    },
    required: {
      id: 'secureMessage.Reply.Required',
      defaultMessage: 'Required',
    },
  },
  replyTextboxPlaceholder: {
    id: 'secureMessage.Reply.TextboxPlaceholder',
    defaultMessage: 'Write a reply...',
  },
  replyTo: {
    id: 'secureMessage.Reply.To',
    defaultMessage: 'To: {name}',
  },
};
